import {Component, OnInit, Input, ChangeDetectorRef, OnChanges, SimpleChanges} from '@angular/core';
import { InputGridModel } from '../input-grid.model';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { COMPONENT_MODE } from '../../workflow-components.models';
import { FormGroup } from '@angular/forms';
import { DynamicFormControlModel } from '@ng-dynamic-forms/core';
import {v4 as uuidv4} from 'uuid';

@Component({
    selector: 'abw-input-grid-result',
    templateUrl: './input-grid-result.component.html',
    styleUrls: ['./input-grid-result.component.scss']
})
export class InputGridResultComponent implements OnInit, OnChanges {
	@Input() model: InputGridModel;
    @Input() value: any[];
    rowsFormsGroup: FormGroup[] = [];
    rowsFormsModel: DynamicFormControlModel[][] = [];

    constructor(
        private _workflowComponentsService: WorkflowComponentsService,
        private _cdf: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!!changes.value?.currentValue) {
            this._buildGridForm();
        }
    }

    private async _buildGridForm() {
        const rowsFormsModel = [];
        const rowsFormsGroup = [];
        if (!!this.value) {
            for (var i = 0; i < this.value.length; i++) {
                for (var j = 0; j < this.model.gridColumns.length; j++) {
                    const valueColumn = this.value[i][this.model.gridColumns[j].ID];
                    this.model.gridColumns[j].DEFAULT_VALUE = valueColumn;
                }
                const rowFormModel = await this._workflowComponentsService.doBuildWorkflowModel(this.model.gridColumns, { COMPONENTS_MODE: COMPONENT_MODE.CONSULTATION, responseWorkflowLocalId: uuidv4() });
                const rowFormGroup = await this._workflowComponentsService.doBuildWorkflowFormGroup(rowFormModel);
                rowsFormsModel.push(rowFormModel);
                rowsFormsGroup.push(rowFormGroup);
            }
        }
        this.rowsFormsModel = rowsFormsModel;
        this.rowsFormsGroup = rowsFormsGroup;
        this._cdf.detectChanges();
    }
}